import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="privacy-policy" element={
        <Suspense fallback={<div className="loading">Loading...</div>}>
          <PrivacyPolicy />
        </Suspense>
      } />
      <Route path="terms" element={
        <Suspense fallback={<div className="loading">Loading...</div>}>
          <TermsOfService />
        </Suspense>
      } />
    </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
